import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RoleStreamFilters } from '../models/roleStreamFilters';

@Injectable({
    providedIn: 'root'
})
export class FilterStreamService {
    public filterStreamRoles = new RoleStreamFilters({});
    public roleFiltersSubject = new BehaviorSubject(this.filterStreamRoles);

    constructor() {
        if(this.getLocalRoleFilters()) {
            this.filterStreamRoles=this.getLocalRoleFilters();
            this.roleFiltersSubject.next(this.filterStreamRoles);
        }
    }

    public updateRoleStreamFilterValues(
        property:string,
        value:boolean
    ) {
        this.filterStreamRoles[property]=value;
        this.roleFiltersSubject.next(this.filterStreamRoles);
        this.setLocalRoleFilters(this.filterStreamRoles);
    }

    public setLocalRoleFilters(roleStreamFilters: RoleStreamFilters){
        localStorage.setItem('roleStreamFilters', JSON.stringify(roleStreamFilters));
    }

    public getLocalRoleFilters(){
        return JSON.parse(localStorage.getItem('roleStreamFilters'));
    }
}
